import { Currency, InstrumentType } from '../types/common';

export const makeIds = <T extends InstrumentType, C extends Currency>(type: T, currecies: C[]) =>
  currecies.map((currency) => `${type}_${currency}` as const);
